import { render, staticRenderFns } from "./ChartWithMoneyAxis.vue?vue&type=template&id=47b621ad&lang=pug&"
import script from "./ChartWithMoneyAxis.vue?vue&type=script&lang=ts&"
export * from "./ChartWithMoneyAxis.vue?vue&type=script&lang=ts&"
import style0 from "./ChartWithMoneyAxis.vue?vue&type=style&index=0&id=47b621ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports